module.exports = __webpack_public_path__ + "img/vende_tu_auto_paso3_tablet.8e44b1ca.png";